import { makeArray } from 'garaje/utils/make-array';
export default function arrayToSentence(arr: string[]): string {
  arr = makeArray(arr).filter(Boolean);
  if (arr.length === 2) {
    return arr.join(' and ');
  } else {
    const last = arr.pop();
    const rest = arr.length ? arr.join(', ') : null;
    return [rest, last].filter(Boolean).join(', and ');
  }
}
